import React, { useState, useCallback, useRef } from 'react';

const TYPES = {
  success: { bg: 'rgba(34,197,94,0.15)', border: 'rgba(34,197,94,0.3)', color: '#22c55e', icon: '\u2713' },
  error: { bg: 'rgba(239,68,68,0.15)', border: 'rgba(239,68,68,0.3)', color: '#f87171', icon: '\u2717' },
  warning: { bg: 'rgba(245,158,11,0.15)', border: 'rgba(245,158,11,0.3)', color: '#fbbf24', icon: '!' },
  info: { bg: 'rgba(99,102,241,0.15)', border: 'rgba(99,102,241,0.3)', color: '#818cf8', icon: 'i' }
};

const styles = {
  container: {
    position: 'fixed', top: 70, right: 16, zIndex: 9999,
    display: 'flex', flexDirection: 'column', gap: 8
  },
  toast: (type) => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 16px', borderRadius: 10, minWidth: 300, maxWidth: 420,
    backgroundColor: TYPES[type].bg, color: TYPES[type].color,
    border: `1px solid ${TYPES[type].border}`,
    boxShadow: '0 8px 24px rgba(0,0,0,0.3)', fontSize: 13, fontWeight: 500,
    animation: 'slideInRight 0.3s ease',
    backdropFilter: 'blur(8px)'
  }),
  icon: (type) => ({
    width: 22, height: 22, borderRadius: '50%', display: 'flex',
    alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 11,
    backgroundColor: TYPES[type].color, color: '#0f172a', flexShrink: 0
  }),
  close: {
    marginLeft: 'auto', background: 'none', border: 'none',
    cursor: 'pointer', fontSize: 16, opacity: 0.5, padding: 4,
    color: 'inherit'
  }
};

let toastIdCounter = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const supprimer = useCallback((id) => {
    clearTimeout(timers.current[id]);
    delete timers.current[id];
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const ajouter = useCallback((message, type = 'info', duree = 4000) => {
    const id = ++toastIdCounter;
    setToasts(prev => [...prev, { id, message, type }]);
    timers.current[id] = setTimeout(() => supprimer(id), duree);
    return id;
  }, [supprimer]);

  const succes = useCallback((msg) => ajouter(msg, 'success'), [ajouter]);
  const erreur = useCallback((msg) => ajouter(msg, 'error', 6000), [ajouter]);
  const attention = useCallback((msg) => ajouter(msg, 'warning'), [ajouter]);
  const info = useCallback((msg) => ajouter(msg, 'info'), [ajouter]);

  const ToastContainer = () => (
    <div style={styles.container}>
      {toasts.map(t => (
        <div key={t.id} style={styles.toast(t.type)}>
          <span style={styles.icon(t.type)}>{TYPES[t.type].icon}</span>
          <span>{t.message}</span>
          <button style={styles.close} onClick={() => supprimer(t.id)}>&times;</button>
        </div>
      ))}
    </div>
  );

  return { ToastContainer, succes, erreur, attention, info };
}
